export default __webpack_public_path__ + "static/media/about-us-mobile-img.ef599462.png";